<p-fieldset>
    <ng-template pTemplate="header">
        <div class="header-title">
            {{headerTitle}}
             <i *ngIf="helpComponent" class="pi pi-question-circle help-icon" (click)="onHelpClicked()"></i>
        </div>
    </ng-template>
    <div class="content" *ngIf="dataBoxItems">
        <div class="data-item" *ngFor="let item of dataBoxItems; let i = index;" [class.left-divider-1]="i > 0">
            {{item.value}}
            <div class="item-label">{{item.label}}</div>
        </div>
    </div>
</p-fieldset>